import {makeObservable, observable} from "mobx";
import BlockObject from "./BlockObject";

export default class FacebookBlockObject extends BlockObject implements IFacebookBlockObj {

    appId: string;
    linkType: string;

    constructor(blockType: OrganizationType, initialBlockObj: IBlockObj | undefined) {
        super(blockType, initialBlockObj);
        this.setAttributes(initialBlockObj);
        makeObservable(this, {
            appId: observable,
            linkType: observable,
        })
    }

}
